import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { ProductInvoice } from './product-invoice'

export class ProductInvoicesRepository extends BaseRepository<ProductInvoice> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/product-invoices', token, cache)
    }

    async upsert(dto: Partial<ProductInvoice>) {
        const { json, statusCode, message } = await this.request.post(
            this.config.posApiUrl + '/product-invoices/?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
